module.exports = __webpack_public_path__ + "img/@logo_shinhanlife.cff1f515.png";